import * as Sentry from '@sentry/react';
import { YWT_PUBLIC_CONFIG } from '@cuspar/ywt.ch.config/public';

const dsn = YWT_PUBLIC_CONFIG.sentry.frontend.dsn;

export function initSentry() {
  if (!dsn) return;
  Sentry.init({
    dsn,
    // Tunnel through our own backend so tracker-blocking browsers
    // (Edge, Brave, uBlock) can't drop the outbound request.
    tunnel: `${YWT_PUBLIC_CONFIG.backend.url}/monitoring/sentry`,
    environment: YWT_PUBLIC_CONFIG.environment,
    release: `ywt-frontend@${YWT_PUBLIC_CONFIG.version.version}`,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    beforeSend(event) {
      return scrubFormData(event);
    },
    beforeBreadcrumb(crumb) {
      return scrubBreadcrumb(crumb);
    },
  });
}

function scrubFormData(event: Sentry.ErrorEvent): Sentry.ErrorEvent {
  // Strip query strings on contact/order/auth routes — they sometimes carry
  // identifiers we don't want in error reports.
  if (event.request?.url) {
    try {
      const u = new URL(event.request.url);
      if (/\/(contact|order|auth|cart|checkout)\b/i.test(u.pathname)) {
        u.search = '';
        event.request.url = u.toString();
      }
    } catch {
      // ignore malformed URLs
    }
  }
  return event;
}

function scrubBreadcrumb(crumb: Sentry.Breadcrumb): Sentry.Breadcrumb | null {
  // Sentry default-captures fetch/xhr breadcrumbs with full URL but not body —
  // good. We strip query strings on sensitive paths to be safe.
  if (crumb.category === 'fetch' || crumb.category === 'xhr') {
    const url: string | undefined = crumb.data?.url;
    if (url && /\/(contact|order|auth|cart|checkout)\b/i.test(url)) {
      try {
        const u = new URL(url, window.location.origin);
        u.search = '';
        crumb.data!.url = u.toString();
      } catch {
        // ignore
      }
    }
  }
  return crumb;
}

export { Sentry };
